import { UrlApi } from "../../../../../../services/apirest";

export const getNotas = async (idCliente, envasado) => {
  const res = await fetch(
    `${UrlApi}/cuentacorriente/notas/${idCliente}/${envasado}`,
  );

  if (!res.ok) throw new Error("Error al obtener notas");

  return await res.json();
};

export const crearNota = async (body) => {
  const res = await fetch(`${UrlApi}/cuentacorriente/notas`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) throw new Error("Error al crear nota");

  return await res.json();
};

export const editarNota = async (id, nota) => {
  const res = await fetch(`${UrlApi}/cuentacorriente/notas/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ nota }),
  });

  if (!res.ok) throw new Error("Error al editar nota");

  return await res.json();
};

export const eliminarNota = async (id) => {
  const res = await fetch(`${UrlApi}/cuentacorriente/notas/${id}`, {
    method: "DELETE",
  });

  if (!res.ok) throw new Error("Error al eliminar nota");

  return await res.json();
};
